<template>
	<ul class="m-product-list">
		<li v-for="(item, i) in unitData.product_list" :key="item.product_id">
			<div class="image-box">
				<sub-image class="image" :src="item.product_img_url"></sub-image>
				<p class="name ellipsis-2">{{item.product_name}}</p>
			</div>
			<div class="info flex-between-center">
				<div class="price">
					<span>特惠价<b>￥</b><strong>{{parseFloat(item.sale_price)}}</strong></span>
				</div>
				<div class="button">立即抢购</div>
			</div>
		</li>
	</ul>
</template>

<script>
	export default {
		data() {
			return {
				unitData: {}
			}
		},
		
		mounted() {
		},
		
		methods: {
		}
	}
</script>

<style lang="stylus" scoped>
	.m-product-list {
		padding: 0 12px;
		
		li {
			border-radius: 6px;
			padding: 10px 10px 0;
			background: #00AF5B;
			box-shadow: 0px 2px 5px 0px rgba(0,175,91,.3);
			
			&:nth-child(n+2) {
				margin-top: 16px;
			}
			
			.image {
				width: 331px;
				height: 331px;
				overflow: hidden;
				
				&-box {
					position: relative;
					border-radius: 8px;
					overflow: hidden;
				}
			}
			
			.name {
				padding: 10px 14px;
				line-height: 22px;
				font-size: 16px;
				color: #333;
				background: #fff;
			}
			
			.info {
				height: 55px;
				
				.price {
					font-size: 15px;
					color: #fff;
					
					strong {
						font-size: 22px;
					}
				}
				
				.button {
					border-radius: 6px;
					padding: 0 10px;
					line-height: 36px;
					font-size: 16px;
					font-weight: bold;
					background: #FEE405;
				}
			}
		}
	}
</style>
